<p-multiSelect [options]="values" [(ngModel)]="selectedValues"></p-multiSelect>